export const USER_CATEGORY_ID: { [key: string]: number } = {
    Icertis: 1,
    Partner: 2,
    Customer: 3
  };

export const USER_ROLE_ID: { [key: string]: number } = {
    NonIDNUser: 9,    
  };
export const BEC_USER_LIMIT = 5000;

export const REQUEST_TYPE: { [key: string]: number } = {
  GIFTroubleShooter: 12,
  ResetServices : 14,
  AddInRoleRestart : 10
};

export const DATABASE_LOG_TABLE: { [key: string]: string } = {
  TaskEvent: "Task Event",
  Interest: "Interest",
  Setting: "Setting",
  ClientAppErrorMapping: "Client App Error Mapping",
  LegacyGlobalSettings : "Legacy Global Settings",
  InboxStatus : "Inbox Status"

};
export const DATE_FORMAT_STRING = "dd MMMM, yyyy 'at' HH:mm '(UTC)'";

export const DEPLOYMENT_REQUEST_TYPE: { [key: string]: number } = {
  Requested: 1,
  InProgress: 2,
  Rejected: 3,
  Completed: 4,
  Failed: 5,
  BundlingStarted: 6,
  BundlingFailed: 7,
  BundlingCompleted: 8,
  Pending: 9,
  Scheduled: 10,
  Cancelled: 11
};

export const STATUS: { [key: string]: string } = {
   InProgress: 'In Progress',
   Failed: 'Failed',
   Success: 'Success',
   Complete: 'Complete',
   NotStarted: 'Not started'
};

export const STATUS_ID: { [key: string]: number } = {
  Pending: 0,
  InProgress: 1,
  Failed: 2,
  Success: 3,  
};

export const EXTENSION_TYPE = 4;